import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const EVENT_DATE = new Date('2026-01-15T18:00:00');

const HomePage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [timeLeft, setTimeLeft] = useState({});

  const rules = [
    'Etkinlik 18 yaş ve üzeri katılımcılara açıktır.',
    'Etkinlik alanına kesici, delici alet, yanıcı–patlayıcı maddeler ve yasadışı unsurların sokulması kesinlikle yasaktır.',
    'Etkinlik süresince fotoğraf ve video çekimi yapılabilir.',
    'Taşkınlık ve çevreye zarar veren davranışlara tolerans yoktur.',
    'Kişisel eşyalardan organizasyon sorumlu değildir.',
    'Satın alınan biletler iade edilemez.',
    'Katılan herkes kuralları kabul etmiş sayılır.'
  ];

  useEffect(() => {
    fetchStats();
    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  }, []);

  const fetchStats = async () => {
    try {
      const res = await axios.get(`${API}/event/stats`);
      setStats(res.data);
    } catch (e) { console.error(e); } finally { setLoading(false); }
  };

  const updateCountdown = () => {
    const diff = EVENT_DATE - new Date();
    if (diff <= 0) return;
    setTimeLeft({
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60)
    });
  };

  return (
    <div className="min-h-screen bg-black text-white relative overflow-x-hidden font-sans select-none">
      
      {/* 🔴 ARKA PLAN */}
      <div className="fixed inset-0 bg-[radial-gradient(circle_at_50%_40%,_#400_0%,_#000_70%)] z-0"></div>
      
      {/* ❄️ KAR EFEKTİ */}
      <div className="snowfall pointer-events-none fixed inset-0 z-20">
        {[...Array(35)].map((_, i) => (
          <div key={i} className="snowflake text-white/20" style={{
            left: `${Math.random() * 100}%`,
            animationDuration: `${Math.random() * 10 + 5}s`,
            animationDelay: `${Math.random() * 5}s`
          }}>❄</div>
        ))}
      </div>

      <div className="relative z-10 w-full max-w-[1200px] mx-auto px-6 pt-10 pb-40">
        
        {/* 1. ORGANİZASYON ADI (Ö harfini kapatmaması için margin artırıldı) */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block tracking-[0.5em] text-[10px] md:text-xs font-black border-b-2 border-red-600 pb-2 text-red-500 uppercase">
            PWR ORGANİZASYONU SUNAR
          </span>
        </div>

        {/* 2. BAŞLIK */}
        <header className="text-center mb-8">
          <h1 className="text-[17vw] md:text-[11rem] font-[1000] italic tracking-tighter leading-[0.8] uppercase drop-shadow-[0_10px_30px_rgba(220,38,38,0.6)]">
            <span className="block text-white">SÖMESTR</span>
            <span className="block text-transparent bg-clip-text bg-gradient-to-b from-red-600 to-red-900">PARTY</span>
          </h1>
        </header>

        {/* 3. TARİH & SAAT */}
        <div className="flex flex-col items-center gap-2 mb-10">
           <div className="bg-white text-black px-8 py-2 font-black italic text-2xl md:text-4xl skew-x-[-15deg]">
             15 OCAK
           </div>
           <div className="text-xl md:text-3xl font-black tracking-widest text-white italic">
             18:00 – 22:00
           </div>
        </div>

        {/* 4. KIRMIZI VE SARI ALAN (BİLET VE FİYAT) */}
        <div className="flex justify-center items-center gap-4 md:gap-10 mb-14">
           {/* KIRMIZI ALAN: KALAN BİLET */}
           <div className="flex-1 max-w-[200px] aspect-video border-2 border-red-600 bg-red-600/10 flex flex-col items-center justify-center rounded-sm relative overflow-hidden group">
              <span className="text-[10px] font-black text-red-500 tracking-tighter uppercase mb-1">KALAN BİLET</span>
              <span className="text-4xl md:text-6xl font-black text-white italic">
                {loading ? '..' : stats?.remaining_tickets ?? 0}
              </span>
              <div className="absolute top-0 right-0 w-2 h-2 bg-red-600 animate-ping"></div>
           </div>

           {/* SARI ALAN: FİYAT */}
           <div className="flex-1 max-w-[200px] aspect-video bg-yellow-400 border-2 border-black flex flex-col items-center justify-center rounded-sm shadow-[5px_5px_0px_#ca8a04] transform rotate-2">
              <span className="text-[10px] font-black text-black/60 tracking-tighter uppercase">GİRİŞ ÜCRETİ</span>
              <span className="text-3xl md:text-5xl font-[1000] text-black tracking-tighter">1.000 TL</span>
              <div className="text-[8px] font-bold text-black/40 mt-1 uppercase">Party Pass</div>
           </div>
        </div>

        {/* 5. GERİ SAYIM */}
        <div className="grid grid-cols-4 gap-2 md:gap-8 mb-20 max-w-2xl mx-auto py-6 border-y border-white/10">
          {[
            ['GÜN', timeLeft.days],
            ['SAAT', timeLeft.hours],
            ['DK', timeLeft.minutes],
            ['SN', timeLeft.seconds]
          ].map(([label, val], i) => (
            <div key={i} className="text-center">
              <div className={`text-4xl md:text-7xl font-black leading-none ${label === 'DK' ? 'text-red-600' : 'text-white'}`}>
                {val ?? '00'}
              </div>
              <div className="text-[9px] font-bold text-gray-500 tracking-widest mt-2">{label}</div>
            </div>
          ))}
        </div>
        {/* 6. BUTONLAR */}
        <div className="flex flex-col md:flex-row gap-4 w-full max-w-2xl mx-auto mb-32">
          {!isAuthenticated ? (
            <>
              <button onClick={() => navigate('/register')} className="flex-1 bg-red-600 text-white font-black text-2xl py-6 uppercase italic hover:bg-white hover:text-black transition-all active:scale-95 shadow-xl">KAYDOL</button>
              <button onClick={() => navigate('/login')} className="flex-1 bg-white text-black font-black text-2xl py-6 uppercase italic hover:bg-red-600 hover:text-white transition-all active:scale-95">GİRİŞ</button>
            </>
          ) : (
            <button onClick={() => navigate(user?.is_admin ? '/admin' : '/reservation')} className="w-full bg-red-600 text-white font-black text-3xl py-8 uppercase animate-pulse shadow-2xl">REZERVASYON YAP</button>
          )}
        </div>

        {/* 📜 KURALLAR */}
        <section className="max-w-4xl mx-auto border-t border-red-900/50 pt-16">
          <h2 className="text-3xl font-black italic mb-10 text-center text-red-600 tracking-tighter uppercase">GECENİN YASALARI</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {rules.map((rule, idx) => (
              <div key={idx} className="flex gap-3 bg-white/5 p-4 border-l-2 border-red-600">
                <span className="text-red-600 font-black">#</span>
                <p className="text-xs font-bold text-gray-300">{rule}</p>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* 📱 MOBILE NAVIGATION */}
      {!isAuthenticated && (
        <div className="fixed bottom-0 left-0 right-0 z-[100] md:hidden bg-black/90 backdrop-blur-xl border-t-2 border-red-600 p-4 flex gap-2">
          <button className="flex-1 bg-red-600 text-white font-black py-5 text-xl uppercase italic shadow-lg shadow-red-600/20" onClick={() => navigate('/register')}>KAYDOL</button>
          <button className="flex-1 bg-white text-black font-black py-5 text-xl uppercase italic" onClick={() => navigate('/login')}>GİRİŞ</button>
        </div>
      )}

      <style jsx="true">{`
        .snowflake { position: fixed; top: -10%; z-index: 1; animation: fall linear infinite; }
        @keyframes fall { 0% { transform: translateY(-10vh) rotate(0deg); } 100% { transform: translateY(110vh) rotate(360deg); } }
      `}</style>
    </div>
  );
};

export default HomePage;
